import type { AmplitudeEvent } from "@app/types/tracking/common";
import type {
  ClickedRouteCalendarDeparture,
  ClickedRouteCalendarMore,
  ClickedRouteCalendarTab,
  ShowPriceCalendar
} from "@app/types/tracking/price-calendar";

import { PriceCalendarTrackingAction } from "./constants/tracking-action";

export function clickedRouteCalendarTab(
  index: number
): AmplitudeEvent<ClickedRouteCalendarTab> {
  return {
    action: PriceCalendarTrackingAction.ClickedRouteCalendarTab,
    details: {
      has_price: false,
      day_selected: index
    }
  };
}

export function clickedRouteCalendarMore(
  index: number
): AmplitudeEvent<ClickedRouteCalendarMore> {
  return {
    action: PriceCalendarTrackingAction.ClickedRouteCalendarMore,
    details: {
      day_selected: index
    }
  };
}

export function clickedRouteCalendarDeparture(
  index: number,
  annotation?: string
): AmplitudeEvent<ClickedRouteCalendarDeparture> {
  return {
    action: PriceCalendarTrackingAction.ClickedRouteCalendarDeparture,
    details: {
      day_selected: index,
      annotation
    }
  };
}

export function showPriceCalendar(
  data_source?: string,
  show_prices?: boolean
): AmplitudeEvent<ShowPriceCalendar> {
  return {
    action: PriceCalendarTrackingAction.ShowPriceCalendar,
    details: {
      data_source,
      show_prices
    }
  };
}
